import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectCurrentUserStoryWord = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  ({ task, step }): string => {
    if (!task.story) return '';

    const storyIndex = step.index ?? 0;
    const wordIndex = step.subindex ?? 0;
    return task.story[storyIndex][wordIndex];
  }
);
